import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { changes } from "src/components/utils/fields";
import { useMediaQuery } from "@mui/material";
import {
  BufferService,
  LoadingContext,
  NavigateContext,
  M_Button,
  M_Fieldset,
  M_Header,
} from "src/M_Components";
import { Info, Refresh, Send } from "@mui/icons-material";
import { QuoteInfo } from "./components/QuoteInfo";
import { QuoteDates } from "./components/QuoteDates";
import { QuotePorts } from "./components/QuotePorts";
import { QuoteEntities } from "./components/QuoteEntities";
import { QuoteEquipment } from "./components/QuoteEquiment";
import { QuoteGoods } from "./components/QuoteGoods";
import { QuoteCalculator } from "./components/QuoteCalculator";
import { QuoteCharges } from "./components/QuoteCharges";
import { QuoteRequestDates } from "./components/QuoteRequestDates";
import { getLoggedUserEmail } from "./components/QuoteFormField";
import { getQuoteApiErrorMessage } from "./utils/quoteApiError";
import { hasCurrency, hasGoodsDescription, hasGuid, hasValue, buildQuotePayload, hydrateGoodsFromQuoteDescription, normalizeQuoteEquipmentsForSave, normalizeQuoteGoodsForSave, resolveQuoteGoodsDescription } from "./utils/quoteValidation";
import { parseSessionStorageItem } from "./utils/quoteSessionStorage";
import {
  QuoteEquipmentGoodsSection,
  QuoteInfoDatesPortsSection,
} from "./components/QuotePageSections";

export const QuoteRequest = ({ roles }) => {
  const [id, setId] = useState(sessionStorage.getItem("selectedTab"));
  const { t } = useTranslation();
  const ctx = useContext(LoadingContext);
  const navigateCtx = useContext(NavigateContext)
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [passedRow, setPassedRow] = useState({});
  const [operation, setOperation] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [triggerAddNewCharge, setTriggerAddNewCharge] = useState(false);

  const accountService = new BufferService("Account");
  // const quoteService = new BufferService("Quote");
  const quoteGetRequestService = new BufferService("quotegetrequest");
  const quoteCreateRequestService = new BufferService("quotecreaterequest");
  const quoteUpdateRequestService = new BufferService("quoteupdaterequest");

  const sessionKeys = ["operation", "data", "open", "passedRow"];

  const matches11 = useMediaQuery("(min-width:970px)");
  const matches12 = useMediaQuery("(min-width:930px)");
  const matches16 = useMediaQuery("(min-width:440px)");

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true);
      getSessionStorageData(id);
      setIsFirstTime(false);
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
    }
  }, []);

  useEffect(() => {
    const passOperation = ctx.passValue.get("operation");
    setOperation(passOperation);
  }, []);

  useEffect(() => {
    const newId = sessionStorage.getItem("selectedTab");
    if (newId !== id) {
      setId(newId);
      getSessionStorageData(newId);
    }
  }, []);

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key);
    });
    // eslint-disable-next-line
  }, [id, operation, data]);

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
      return;
    if (eval(value) instanceof String && eval(value) === "") return;
    if (eval(value) instanceof Number && eval(value) === "") return;

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(
        `${id}${key}`,
        JSON.stringify(Array.from(eval(value))),
      );
    } else {
      // eslint-disable-next-line
      const serialized = JSON.stringify(eval(value));
      if (serialized === undefined) return;
      sessionStorage.setItem(`${id}${key}`, serialized);
    }
  };

  const getSessionStorageData = (sessionID) => {
    if (!sessionID) {
      get();
      return;
    }
    ctx.setIsLoad(true);
    const tempO = parseSessionStorageItem(`${sessionID}operation`);
    const tempD = parseSessionStorageItem(`${sessionID}data`);
    const tempOS = parseSessionStorageItem(`${sessionID}open`);
    const tempPR = parseSessionStorageItem(`${sessionID}passedRow`);

    if (
      (tempO && tempO !== "") ||
      (tempD && Object.keys(tempD).length !== 0) ||
      tempOS ||
      (tempPR && Object.keys(tempD).length !== 0)
    ) {
      setOperation(new String(tempO));
      setData(new Object(tempD));
      setOpen(tempOS);
      setPassedRow(tempPR);
      ctx.setIsLoad(false);

      return;
    }
    get();
  };

  const fixResponseObject = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toLowerCase() + key.slice(1),
        value,
      ]),
    );

  const fixResponseListObject = (obj) =>
    obj.map((element) =>
      Object.fromEntries(
        Object.entries(element).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.slice(1),
          value,
        ]),
      ),
    );

  const get = () => {
    console.log("get operation", ctx.passValue.get("operation"))
    const row = ctx.passValue.get("Row")
    const rows = ctx.passValue.get("Rows")

    if (ctx.passValue.get("operation") === "edit" && row) {
      quoteGetRequestService
        .getId(row.Id)
        .then((response) => {
          if (response.name === "AxiosError") {
            ctx.toastMessages(
              "error",
              t("Error"),
              response?.response?.data?.Errors || response.message,
            );
            ctx.setIsLoad(false);
            return;
          }

          const fixedQuoteResponse = fixResponseObject(response.Quote);
          const fixedGoodsResponse = hydrateGoodsFromQuoteDescription(
            fixResponseListObject(response.Goods),
            fixedQuoteResponse,
          );
          const fixedEquipmentResponse = fixResponseListObject(
            response.Equipment,
          );

          delete fixedQuoteResponse.Goods;
          delete fixedQuoteResponse.Equipment;

          const fixedQuoteResponseDates = {
            ...fixedQuoteResponse,
            startDate: fixedQuoteResponse.startDate?.split("T")[0],
            dueDate: fixedQuoteResponse.dueDate?.split("T")[0],
            expireDate: fixedQuoteResponse.expireDate?.split("T")[0],
          };

          const fixedEquipmentTypesResponse = fixedEquipmentResponse.map(
            (equipment) => ({
              ...equipment,
              equipmentType: `${equipment["equipmentTypeLenght"]}${equipment["equipmentTypeCode"]}`,
            }),
          );

          const fixedAllResponses = {
            ...fixedQuoteResponseDates,
            Goods: fixedGoodsResponse,
            Equipments: fixedEquipmentTypesResponse,
          };

          setData(fixedAllResponses);

          ctx.setIsLoad(false);
        })
        .catch((err) => {
          ctx.toastMessages("error", err.message, "Error");
          ctx.setIsLoad(false);
        });
    } else {
      if (rows?.length > 1) {
        setData({ ...data, isMultiEdit: true });
      } else {
        const userEmail = getLoggedUserEmail();
        if (userEmail) {
          changes("createdBy", userEmail, setData);
        }
      }
    }

    changes("totalCurrency", "€", setData);

    getCompanies();
    ctx.setIsLoad(false);
  };

  useEffect(() => {
    if(!triggerAddNewCharge) setTriggerAddNewCharge(true);
  }, [data])

  const getCompanies = () => {
    let tempCompanies = JSON.parse(sessionStorage.getItem("companies"));
    if (tempCompanies.length === 0) {
      ctx.toastMessages("error", "User has no companies!", "");
    }
    if (tempCompanies.length === 1) {
      getAccount(tempCompanies[0]);
    }

    changes(
      "companyOptions",
      tempCompanies.map((field) => {
        return { label: field.Name, value: field.AccountId, ...field };
      }),
      setData,
    );
  };

  const getAccount = (companyOrAccountId) => {
    if (!companyOrAccountId) {
      changes("clientCode", "", setData);
      changes("clientVat", "", setData);
      changes("userCompanyId", "", setData);
      return;
    }
    const accountGuid =
      typeof companyOrAccountId === "object"
        ? companyOrAccountId.AccountId
        : companyOrAccountId;
    if (typeof companyOrAccountId === "object" && companyOrAccountId.Id) {
      changes("userCompanyId", companyOrAccountId.Id, setData);
    }
    accountService.getId(accountGuid).then((res) => {
      if (res.name === "AxiosError") {
        ctx.toastMessages("error", "Couldnt fetch Account!", "");
        return;
      }
      changes("clientCode", res.AccountCode, setData);
      changes("clientVat", res.AccountVATNumber, setData);
      if (res.UserCompanyId) {
        changes("userCompanyId", res.UserCompanyId, setData);
      }
    });
  };

  const validateQuoteRequest = () => {
    const errors = [];

    if (!hasCurrency(data)) {
      errors.push(`${t("Currency")} ${t("IsRequired")}`);
    }
    if (!hasValue(data.startDate)) {
      errors.push(`${t("StartDate")} ${t("IsRequired")}`);
    }
    if (!hasGuid(data.loadingPortId)) {
      errors.push(`${t("LoadingPort")} ${t("IsRequired")}`);
    }
    if (!hasGuid(data.dischargePortId)) {
      errors.push(`${t("DischargePort")} ${t("IsRequired")}`);
    }

    const equipments = data.Equipments || [];
    const hasValidEquipment = equipments.some(
      (e) => Number(e.quantity) >= 1 && e.equipmentTypeId,
    );
    if (!hasValidEquipment) {
      errors.push(`${t("Equipment")} ${t("IsRequired")}`);
    }

    if (!data.remarks || !String(data.remarks).trim()) {
      errors.push(`${t("Remarks")} ${t("IsRequired")}`);
    }
    if (!hasGoodsDescription(data)) {
      errors.push(`${t("GoodsDescription")} ${t("IsRequired")}`);
    }

    return errors;
  };

  const onSave = (status) => {
    const validationErrors = validateQuoteRequest();
    if (validationErrors.length > 0) {
      const isEdit = operation === "edit" || operation === "editRequest";
      ctx.toastMessages(
        "error",
        isEdit ? t("ErrorUpdating") : t("ErrorCreating"),
        validationErrors.join("\n"),
      );
      return;
    }

    const equipments = data.Equipments || [];
    const goods = data.Goods || [];

    const tempEquipments = normalizeQuoteEquipmentsForSave(equipments);

    const tempGoods = normalizeQuoteGoodsForSave(goods);

    const saveData = {
      Equipments: tempEquipments,
      Goods: tempGoods,
      Quote: buildQuotePayload(data, {
        status,
        goodsDescription: resolveQuoteGoodsDescription(data),
      }),
      IsMultiEdit: data.isMultiEdit,
      MultiEditQuoteIds: ctx.passValues?.Rows?.map((x) => x.Id),
    };
    ctx.setIsLoad(true);

    if (operation === "create" || operation === "request") {
      quoteCreateRequestService.post(saveData).then((response) => {
        if (response.name === "AxiosError") {
          const errorDetail = getQuoteApiErrorMessage(response) || t("ErrorCreating");
          ctx.toastMessages(
            "error",
            t("ErrorCreating"),
            errorDetail,
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("CreatedQuoteRequest"),
          );
          ctx.setIsLoad(false);

          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    } else if (operation === "edit" || operation === "editRequest") {
      quoteUpdateRequestService.update(data.id, saveData).then((response) => {
        if (response.name === "AxiosError") {
          const errorDetail = getQuoteApiErrorMessage(response) || t("ErrorUpdating");
          ctx.toastMessages(
            "error",
            t("ErrorUpdating"),
            errorDetail,
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("EditedQuoteRequest"),
          );
          ctx.setIsLoad(false);

          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    }
  };

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("Refresh")}
              icon={<Refresh />}
              label={t("Refresh")}
              onClick={() => get()}
            />
            <M_Button
              tooltip={t("SendQuoteRequest")}
              icon={<Send />}
              label={t("SendQuoteRequest")}
              onClick={() => onSave("W")}
            />
            <M_Button
              tooltip={t("LabelSaveAsDraft")}
              icon={<i className="pi pi-save "></i>}
              label={t("LabelSaveAsDraft")}
              onClick={() => onSave("D")}
            />
          </>
        }
      />
      <div style={{ margin: "20px" }}>
        {data.isMultiEdit && (
          <M_Fieldset
            labelInside
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "25px",
                  marginLeft: "10px",
                }}
              >
                <Info style={{ marginRight: "10px", scale: "1.3" }} />{" "}
                {t("MultiEditInfoTitle")}
              </div>
            }
            elements={<div>{t("MultiEditInfoContent")}</div>}
          />
        )}
        <QuoteInfoDatesPortsSection
          wide={matches11}
          quoteInfo={<QuoteInfo dataState={data} setDataState={setData} requestMode />}
          dates={<QuoteRequestDates dataState={data} setDataState={setData} />}
          ports={<QuotePorts dataState={data} setDataState={setData} requestMode />}
        />
        <QuoteEquipmentGoodsSection
          wide={matches12}
          equipment={<QuoteEquipment dataState={data} setDataState={setData} requestMode />}
          goods={<QuoteGoods dataState={data} setDataState={setData} requestMode />}
        />
        <div style={{ margin: "25px" }}></div>
      </div>
    </div>
  );
};
